import BaseApi from './base.api'
import ApiService from '@services/api.service'

export default {
    ...BaseApi,
    ...{
        resource: 'classes',
        assignStudentsToSubjects(params=null){
            return ApiService.post(`/${this.resource}/assign-students-to-subjects`,params)
        },
        getTypes(params = null) {
            return ApiService.get(`/${this.resource}/types`, params)
        },
        getTypes(params = null) {
            return ApiService.get(`/${this.resource}/types`, params)
        },
        syncTeamsClass(classId) {
            return ApiService.post(`/${this.resource}/sync-one`, {
                class_id: classId,
            })
        }
    }
}
